/* subscription-options-text.js
   Removes "Deliver"/"Delivery" from option labels WITHOUT duplicating text.
*/

(function () {
  function cleanedText(original) {
    return original
      .replace(/^\s*(Deliver|Delivery)\s*/i, '') // drop leading "Deliver/Delivery"
      .replace(/\s+/g, ' ')                      // normalize spaces
      .trim();
  }

  function fixLabel(label) {
    // Only affect the option labels inside the list (not the heading)
    const input = label.querySelector('input[type="radio"]');
    if (!input) return;

    // Gather existing non-empty text nodes
    const textNodes = Array.from(label.childNodes).filter(
      (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length
    );

    // Compute the cleaned string from the concatenated text
    const original = textNodes.map((n) => n.textContent).join(' ').trim();
    const cleaned = cleanedText(original);

    // Ensure exactly ONE text node immediately after the input
    // 1) If no text node exists, create one
    if (textNodes.length === 0) {
      const tn = document.createTextNode(' ' + cleaned);
      input.after(tn);
      return;
    }

    // 2) Set the first text node to the cleaned text (with a leading space for spacing)
    textNodes[0].textContent = ' ' + cleaned;

    // 3) Remove any additional text nodes to avoid duplication
    for (let i = 1; i < textNodes.length; i++) {
      textNodes[i].remove();
    }
  }

  function updateAll(container) {
    // Only the option labels inside the UL
    container
      .querySelectorAll('.shopify_subscriptions_app_block_label_children > li > label')
      .forEach(fixLabel);
  }

  function boot() {
    document.querySelectorAll('.shopify_subscriptions_app_container').forEach((c) => {
      updateAll(c);

      // Re-run when the app re-renders (e.g., on variant change)
      const mo = new MutationObserver(() => {
        clearTimeout(c.__subsTextTimer);
        c.__subsTextTimer = setTimeout(() => updateAll(c), 60);
      });
      mo.observe(c, { childList: true, subtree: true });

      // Also re-run when variant changes on the product form
      const form = c.closest('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('change', (e) => {
          if (e.target && e.target.name === 'id') {
            setTimeout(() => updateAll(c), 80);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();